import {checkToken} from "@/utils/lambdaUtils.js";
import {useAuthStore} from "@/stores/authStore.js";
import axios from "axios";
import logger from "@/utils/logger.js";
import {UserModel} from "@/models/UserModel.js";

const baseUrl = import.meta.env.VITE_APP_API_BASE_URL + '/user/';

/**
 * Record user login to the database and fetch back any user specific attributes.
 * @returns {Promise<*>}
 */
export const userLogin = async () => {
    try {
        await checkToken();
        const store = useAuthStore();
        const response = await axios.get(`${baseUrl}login`,
            {
                headers: {
                    'Authorization': `Bearer ${store.token}`,
                }
            });
        return new UserModel(response.data);
    } catch (error) {
        logger.error('Error executing userLogin', error);
    }
};